/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".grid-container{height:100%;width:100%}  #generic-table{overflow:hidden}  #generic-table td,   #generic-table th{height:20px!important;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}  .dirty-entity-row{border-left:4px solid #44f!important}  .previous-month-entity-row{color:gray!important}  .ui-autocomplete-input{width:calc(100% - 25px)}"];
export { styles as styles };
